import {
    ResponseFill,
    HttpIgnore, IResource, ValidationRequired, Model, toString,
} from 'simpli-web-sdk'
import * as Helper from '@/helpers'
import moment from 'moment'
import {ItrackCollection} from '@/helpers'

@HttpIgnore()
export default class DeliveryTrackingRequest extends Model {
    readonly $name: string = 'DeliveryTrackingRequest'

    idFilial = Helper.getIdFilial()

    monthCollection = ItrackCollection.getMonthCollection().prependNull('app.all')
    yearCollection = ItrackCollection.getYearCollection().prependNull('app.all')

    @ResponseFill()
    idMotorista: string | number | null = null

    @ResponseFill()
    dia: number | null = null

    @ResponseFill()
    mes: number | null = moment().month() + 1

    @ResponseFill()
    ano: number | null = moment().year()

    date: string = moment().format()

    get dayCollection() {
        return ItrackCollection.getDayCollection(this.date).prependNull('app.all')
    }

    get dayResource() {
        return this.dayCollection.get(this.dia)
    }
    set dayResource(val: IResource | null) {
        this.day = val && val.$id as number || moment().day()
        this.dia = val && val.$id as number || null
    }

    get day() {
        return Number(moment(this.date).format('DD')) || 0
    }
    set day(val: number) {
        this.date = moment(this.date).date(val).format()
    }

    get monthResource() {
        return this.monthCollection.get(this.mes)
    }
    set monthResource(val: IResource | null) {
        this.month = val && val.$id as number || 0
        this.mes = val && val.$id as number || null
    }

    get yearResource() {
        return this.yearCollection.get(this.ano)
    }
    set yearResource(val: IResource | null) {
        this.year = val && val.$id as number || moment().year()
        this.ano = val && val.$id as number || null
    }

    get month() {
        return Number(moment(this.date).format('MM')) || 0
    }
    set month(val: number) {
        this.date = moment(this.date).month(val - 1).format()
    }

    get year() {
        return Number(moment(this.date).format('YYYY')) || 0
    }
    set year(val: number) {
        this.date = moment(this.date).year(val).format()
    }
}
